var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.37 4.15a.51.51 0 1 0-.72.72L7.28 8.5l-3.63 3.63a.51.51 0 0 0 .72.72L8 9.22l3.63 3.63a.51.51 0 0 0 .72-.72L8.72 8.5l3.63-3.63a.51.51 0 0 0-.72-.72L8 7.78z"
})));
export default SvgClose;